// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S9csg","footer":"styles_footer__1M11V","passCodeTooltip":"styles_passCodeTooltip__Tfb3E"};